const organizations = {
    title: 'Організації',
    description: 'Створюйте організації та керуйте організаціями, до яких належите.',
    create: 'Створити організацію',
    create_title: 'Створити нову організацію',
    name: 'Назва організації',
    avatar: 'Аватар організації',
    avatar_removed: 'Аватар організації видалено.',
    description_label: 'Опис',
    empty: 'Ви ще не належите до жодної організації.',
    pending_invitations: 'Запрошення, що очікують',
    accept: 'Прийняти',
    decline: 'Відхилити',
    owner: 'Власник',
    tabs: {
        overview: 'Огляд',
        members: 'Учасники',
        invitations: 'Запрошення',
        roles: 'Ролі керування',
        branding: 'Оформлення',
        security: 'Безпека',
        jit: 'JIT-підготовка',
        applications: 'Спільні ресурси',
        activity: 'Активність',
        deletion: 'Видалення',
    },
    members: {
        title: 'Учасники',
        empty: 'Учасників не знайдено.',
        remove: 'Видалити',
        removed: 'Учасника видалено.',
        business_roles: 'Бізнес-ролі',
        no_business_roles: 'Немає доступних бізнес-ролей. Попросіть адміністратора тенанта надати ролі цій організації.',
    },
    invitations: {
        title: 'Запрошення',
        invite: 'Запросити учасника',
        email: 'Електронна адреса',
        empty: 'Запрошень не знайдено.',
        resend: 'Надіслати повторно',
        resent: 'Запрошення надіслано повторно.',
        revoke: 'Відкликати',
        revoked: 'Запрошення відкликано.',
        status: {
            Pending: 'Очікує відповіді',
            Accepted: 'Прийнято',
            Expired: 'Термін дії минув',
            Revoked: 'Відкликано',
            Declined: 'Відхилено',
        },
    },
    roles: {
        title: 'Ролі керування',
        create: 'Створити роль',
        permissions: 'Дозволи',
        empty: 'Ролей керування не знайдено.',
        select_member: 'Вибрати учасника',
        select_role: 'Вибрати роль',
        assign: 'Призначити роль',
        assigned: 'Роль призначено.',
        unassign: 'Зняти роль',
        unassigned: 'Роль знято.',
        permission_count: 'Дозволів: {{count}}',
        built_in: {
            owner: 'Власник',
            owner_description: 'Власники мають виключні права на керування власністю та видалення організації.',
            administrator: 'Адміністратор',
            administrator_description: 'Керує організацією, окрім дій, доступних лише власникам.',
        },
        permission_labels: {
            update_profile: 'Оновлення профілю',
            manage_branding: 'Керування оформленням',
            view_members: 'Перегляд учасників',
            manage_members: 'Керування учасниками',
            manage_invitations: 'Керування запрошеннями',
            assign_business_roles: 'Призначення бізнес-ролей',
            manage_management_roles: 'Керування ролями керування',
            assign_management_roles: 'Призначення ролей керування',
            manage_security: 'Керування безпекою',
            manage_jit: 'Керування JIT-підготовкою',
            manage_applications: 'Керування застосунками',
            view_activity: 'Перегляд активності',
        },
    },
    branding: {
        title: 'Оформлення організації',
        primary_color: 'Основний колір',
        custom_css: 'Власний CSS',
        preview: 'Попередній перегляд',
        light: 'Світла',
        dark: 'Темна',
    },
    security: {
        title: 'Безпека організації',
        require_mfa: 'Вимагати багатофакторну автентифікацію для учасників',
    },
    jit: {
        title: 'Поштові домени JIT',
        domain: 'Поштовий домен',
        add: 'Додати домен',
        verify: 'Перевірити DNS',
        dns_instruction: 'Створіть запис TXT {{record}} зі значенням {{value}}.',
        verified: 'Підтверджено',
    },
    applications: {
        title: 'Спільні ресурси',
        empty: 'Для цієї організації немає доступних ресурсів.',
        sso: 'Корпоративні SSO-підключення',
        m2m: 'Міжмашинні застосунки',
    },
    activity: {
        title: 'Активність організації',
        empty: 'Активності ще немає.',
        events: {
            create: 'Організацію створено',
            delete: 'Організацію видалено',
            profile: 'Профіль організації оновлено',
            branding: 'Оформлення організації оновлено',
            security: 'Безпеку організації оновлено',
            member_add: 'Учасника додано',
            member_remove: 'Учасника видалено',
            owner: 'Власність організації змінено',
            role_create: 'Роль керування створено',
            role_update: 'Роль керування оновлено',
            role_delete: 'Роль керування видалено',
            role_assign: 'Роль керування призначено',
            role_unassign: 'Роль керування знято з учасника',
            business_role: 'Бізнес-ролі оновлено',
            invitation_create: 'Запрошення надіслано',
            invitation_accept: 'Запрошення прийнято',
            invitation_decline: 'Запрошення відхилено',
            invitation_revoke: 'Запрошення відкликано',
            jit: 'JIT-підготовку оновлено',
            domain: 'Перевірка поштового домену',
            application: 'Підключення застосунків оновлено',
            unknown: 'Активність організації',
        },
    },
    save: 'Зберегти зміни',
    cancel: 'Скасувати',
    delete: 'Видалити організацію',
    delete_confirmation: 'Організацію та її зв’язки з учасниками буде видалено назавжди. Введіть «{{name}}» для підтвердження.',
    deleted: 'Організацію видалено.',
    load_failed: 'Не вдалося завантажити дані організації. Спробуйте ще раз.',
    permission_denied: 'У вас немає дозволу на перегляд цього розділу.',
};
export default organizations;
